import React, { useState } from 'react';
import classes from './Getstarted.module.css'
import { Link } from 'react-router-dom';
import Contactus from '../../Components/Contactus Form/Contactus';

export default function Navigation() {

const [showContact, setShowContact] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);



    return (
        <div>
            <section className={classes.getstarted}>
                <div className={classes.getstartedshi}>
                    <p className={classes.bgtxt}>Get Started today and Build Your Dream Business</p>
                    <p className={classes.smltxt}>We are Future-Proofing Businesses with World-Class Digital Tools</p>
                    <button onClick={() => setShowContact(true)} className={classes.getstartedbtn}>Let’s Work Together</button>
                    <Contactus  show={showContact} setShow={setShowContact} fullscreen={fullscreen} />
                </div>
            </section>
        </div>
    );
}